import './bootstrap'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './components/App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(VueI18n)
Vue.use(Vuetify)

const el = document.body.appendChild(document.createElement('app'))

/* eslint-disable no-new */
new Vue({
  vuetify: new Vuetify(),
  el,
  router,
  store,
  render: h => h(App)
})
